import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { setActiveOverlay } from "../../../redux/Reducer/HealthMap/HealthMapSlice";

const HealthMapReceiptForm = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const selectedPatient = useSelector((s) => s.healthMap.selectedPatient);

    const handleGoToDashboard = () => {
        sessionStorage.setItem("healthmap-patient-context", JSON.stringify({
            ...selectedPatient,
            receiptMode: true,
        }));
        dispatch(setActiveOverlay(null));
        navigate("/studio");
    };

    const calculateAge = (dob) => {
        if (!dob) return null;
        const birthDate = new Date(dob);
        if (isNaN(birthDate.getTime())) return null;
        const today = new Date();
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
            age--;
        }
        return age;
    };

    const age = selectedPatient?.age || calculateAge(selectedPatient?.dateofbirth);

    return (
        <div className="hm-overlay" onClick={() => dispatch(setActiveOverlay(null))}>
            <div className="hm-overlay-panel" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 500 }}>
                <button className="hm-overlay-close" onClick={() => dispatch(setActiveOverlay(null))}>✕</button>
                <div className="hm-overlay-title">🧾 New Receipt</div>
                <div className="hm-overlay-body">
                    <div style={{ marginBottom: 20 }}>
                        <div style={{ display: "flex", gap: 12, alignItems: "center", padding: "16px", borderRadius: 12, background: "var(--hm-today-bg)", border: "1px solid var(--hm-border)", marginBottom: 16 }}>
                            <div style={{ flex: 1 }}>
                                <div style={{ fontWeight: 700, fontSize: 16, color: "var(--hm-text)", marginBottom: 4 }}>
                                    {selectedPatient?.name} {selectedPatient?.surname}
                                </div>
                                <div style={{ display: "flex", alignItems: "center", gap: 8, flexWrap: "wrap" }}>
                                    {selectedPatient?.gender && (
                                        <span className="patient-tag gender" style={{ padding: "1px 8px" }}>{selectedPatient.gender}</span>
                                    )}
                                    {age && (
                                        <span className="patient-tag age" style={{ padding: "1px 8px" }}>{age} Years</span>
                                    )}
                                    <span className="patient-tag phone" style={{ padding: "1px 8px" }}>📞 {selectedPatient?.phoneNumber}</span>
                                </div>
                            </div>
                        </div>

                        <p style={{ fontSize: 13, color: "var(--hm-text-secondary)", lineHeight: 1.6, marginBottom: 8 }}>
                            The receipt maker on Dashboard will open with this patient's details <strong>pre-filled</strong>. 
                            You can add services, amounts, and generate the receipt there.
                        </p>
                        <p style={{ fontSize: 12, color: "var(--hm-text-muted)" }}>
                            Once generated, it will automatically appear on this patient's healthMap.
                        </p>
                    </div>

                    <div style={{ display: "flex", gap: 8, justifyContent: "flex-end" }}>
                        <button className="record-cancel-btn" onClick={() => dispatch(setActiveOverlay(null))}>Cancel</button>
                        <button className="record-save-btn" onClick={handleGoToDashboard}>
                            Go to Receipt Maker →
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HealthMapReceiptForm;
